var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubmitWhite = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Submit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_submit2",
    transform: "translate(3, 2)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector-(Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.333385806,0.331014244 C0.546848973,0.119069503 0.83636716,0 1.13825,0 L8.46649099,0 C8.76811491,0.00026387732 9.05796357,0.119382095 9.27118932,0.331179259 M9.27118932,0.331179259 L11.2507109,2.29662052 C11.3565001,2.40161373 11.4407529,2.52662018 11.4979898,2.66385162 C11.5552096,2.8010431 11.5845976,3.09674993 11.5845976,3.0965518 C11.5845976,3.09641971 11.5845976,3.93905294 11.5845976,5.62445147 C11.5845976,6.04169301 11.2902307,6.37993412 10.87,6.37993412 C10.4497693,6.37993412 10.16,6.04169301 10.16,5.62445147 L10.16,3.25399462 L8.3072909,1.41 L1.42,1.41 L1.42,12.59 L7.05015043,12.59 C7.47038049,12.59 7.81104481,12.8727585 7.81104481,13.29 C7.81104481,13.7072415 7.47038049,14 7.05015043,14 L1.13825,14 C0.836368685,14 0.546850065,13.8809315 0.333385806,13.668986 C0.119921711,13.4570392 0,13.1695804 0,12.8698459 L0,1.1301534 C0,0.830417833 0.119922618,0.542958964 0.333385806,0.331014244 M8.19478611,1.39925996 C8.19486043,1.39933395 8.19486043,1.39933395 8.19478611,1.39925996 Z M10.0628089,3.09595773 C10.0628089,3.09608971 10.0628089,3.09608971 10.0628089,3.09595773 Z",
    fill: "#b8b8ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333385806,0.331014244 L9.27118932,0.331179259 M11.2507109,2.29662052 C11.2507456,2.29665523 11.2507456,2.29665523 11.2507109,2.29662052 Z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.63,0.624426471 C8.05023063,0.624426471 8.34,0.962667479 8.34,1.37990892 L8.34,3.22 L10.1938221,3.22 C10.6140527,3.22 10.9547169,3.5127586 10.9547169,3.93 C10.9547169,4.3472414 10.6140527,4.63319857 10.1938221,4.63319857 L8.05547569,4.63319857 C7.75359407,4.63319857 7.46407481,4.51412972 7.25061075,4.30218423 C7.03714652,4.09023841 6.91722529,3.80277897 6.91722529,3.5030451 L6.91722529,1.37990892 C6.91722529,0.962667479 7.20976937,0.624426471 7.63,0.624426471 Z",
    id: "Vector-(Stroke)",
    fill: "#b8b8ce",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,10.6155082 L12.5,10.6155082 L10.5439541,8.04 M12.5,10.6155082 L10.5439541,13.1910165",
    id: "Vector",
    stroke: "#b8b8ce",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(9.5, 10.6155) rotate(0) translate(-9.5, -10.6155)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubmitWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Submit-White.e23d2b00f32e1268bf577864231872a9.svg";